import React, { useState, useEffect } from "react";
import styles from "./editmedia.module.css";
import { SingleTextInput } from "./SingleTextInput/SingleTextInput";
import { GenreInput } from "./GenreInput/GenreInput";
import { useMedia, useMediaUpdate } from "../../contexts/MediaContext";

import { CreatorSuggestion } from "../SuggestionTypes/CreatorSuggestion/CreatorSuggestion";

import { getFromSearch, patchMedia, postCreator, postMedia, postCover } from "../../api/Api";
import { useNavigate } from "react-router-dom";
import ErrorHandler from "../../helpers/ErrorHandler";

export const EditAlbum = (props) => {

    // props:
    //
    // mediaItem - object containing media information

    // ----------------------------------------------------- STATE AND HOOKS
    let token = localStorage.getItem("token");

    let tokenPeices = token.split(".");
    let idAndRole = atob(tokenPeices[1]);
    let role = idAndRole.split(",")[1];

    let timeOfBackendSearch = Date.now();

    // const mediaItem = useMedia();
    const mediaUpdater = useMediaUpdate();
    const navigator = useNavigate();

    const [editingTitle, setEditingTitle] = useState(props.mediaItem !== null ? props.mediaItem.title : "");
    const [editingDescription, setEditingDescription] = useState(props.mediaItem !== null ? props.mediaItem.description : "");
    const [editingRelease, setEditingRelease] = useState(props.mediaItem !== null ? props.mediaItem.publication : "");
    const [editingNumPages, setEditingNumPages] = useState(props.mediaItem !== null ? props.mediaItem.numpages : "");
    const [editingRestricted, setEditingRestricted] = useState(props.mediaItem !== null ? props.mediaItem.restricted : false);
    const [editingCreator, setEditingCreator] = useState();

    const [file, setFile] = useState(null);

    const [selectedGenres, setSelectedGenres] = useState([]);
    const [selectedCreators, setSelectedCreators] = useState([]);

    const [searchResults, setSearchResults] = useState(null);

    useEffect(() => {
        // sets found genres
        if (props.mediaItem !== null && props.mediaItem.genres && props.mediaItem.genres?.length !== 0) {
            let temp = []
            for (let i = 0; i < props.mediaItem.genres.length; i++) {
                temp.push(props.mediaItem.genres[i].genreID);
            }
            setSelectedGenres(temp);
        }

        // sets found creators
        if (props.mediaItem !== null && props.mediaItem.creators?.length != 0) {
            setSelectedCreators(props.mediaItem.creators)
        }

    }, []);

    // ----------------------------------------------------- TOUCHES BACK
    async function searchForCreator() {
        // searches backend for searies string

        let searchObj = {
            searchString: editingCreator,
            searchType: "Creator"
        }

        await getFromSearch(searchObj, token)
            .then((results) => {
                setSearchResults(["creator", results]);
            })
            .catch((error) => {
                console.log("failed to search for creator", error);
                setSearchResults([]);
                ErrorHandler(error);
            })
    }

    async function addCreatorsToDB() {
        // adds creators to database if necessary
        let creators = [];

        if (selectedCreators?.length === 0 && editingCreator == null) return [];
        else if (selectedCreators?.length != 0) {


            for (let i = 0; i < selectedCreators.length; i++) {

                if (selectedCreators[i].creatorID === null) {
                    // adds creator to database
                    let postModel = {
                        name: selectedCreators[i].name,
                        first: selectedCreators[i].first,
                        last: selectedCreators[i].last
                    }

                    await postCreator(postModel, token)
                        .then((creator) => {
                            creators.push(creator.creatorID);
                        })
                        .catch((error) => {
                            console.log("failed to add creator: ", i, error);
                            ErrorHandler(error);
                        });

                } else {
                    // creator already in database
                    creators.push(selectedCreators[i].creatorID);
                }
            }
        }

        if (editingCreator !== "") {
            // add creator to database NOT selected

            let splitName = editingCreator.split(" ")
            let postModel = {
                name: editingCreator,
                first: splitName.slice(0, -1).join(" "),
                last: splitName.slice(-1).join(" ")
            }

            await postCreator(postModel, token)
                .then((creator) => {
                    creators.push(creator.creatorID);
                })
                .catch((error) => {
                    console.log("failed to add creator", error);
                    ErrorHandler(error);
                });
        }
        return creators;
    }

    async function addMediaToDatabase(creators) {
        // sends media to back
        let mediaPostModel = {
            type: "album",
            title: editingTitle,
            description: editingDescription,
            seriesID: null,
            seriesNum: null,
            creators: creators,
            genreIDs: selectedGenres,
            restricted: editingRestricted,
            publication: editingRelease,
            numpages: editingNumPages,
            isbn: null,
            seasons: null,
            startyear: null,
            endyear: null,
            parentguide: null
        }

        return await postMedia(mediaPostModel, token)
            .then((media) => {
                mediaUpdater(media);
                return media;
            })
            .catch((error) => {
                console.log("failed to add media to database:", error)
                ErrorHandler(error);
            })
    }

    async function updateMedia(creators) {
        // sends updates to back
        let mediaPatchModel = {
            type: "album",
            title: editingTitle,
            description: editingDescription,
            seriesID: null,
            seriesNum: null,
            creators: creators,
            genreIDs: selectedGenres,
            restricted: editingRestricted,
            publication: editingRelease,
            numpages: editingNumPages,
            seasons: null,
            parentguide: null
        }

        await patchMedia( props.mediaItem.mediaid, mediaPatchModel, token)
            .then((media) => {
                mediaUpdater(media);
                navigator("/album/" + media.mediaid)
            })
            .catch((error) => {
                console.log("failed to patch media", error)
                ErrorHandler(error);
            })
    }

    async function addCoverToDB(mediaid) {
        // sends cover to back

        if (file === null) return;

        let newName = "ALBUM" + mediaid + ".jpg";
        let formData = new FormData();
        formData.append(`file`, file, newName);

        await postCover(mediaid, file, token)
            .then((success) => {
                console.log("cover upload status: ", success);
            })
            .catch((error) => {
                console.log("failed to upload cover", error)
                ErrorHandler(error);
            })
    }

    // ----------------------------------------------------- PRE-RENDER

    const handleTitleChange = (value) => {
        // catches changes to title field
        setEditingTitle(value);
    }

    const handleDescriptionChange = (value) => {
        // catches changes to description field
        setEditingDescription(value);
    }

    const handleReleaseChange = (value) => {
        // catches changes to publication field
        setEditingRelease(value);
    }

    const handleNumPagesChange = (value) => {
        // catches changes to numpages field
        setEditingNumPages(value);
    }

    const handleChangeCover = (event) => {
        // catches changes to cover upload
        setFile(event.target.files[0])
    }

    const handleChangeRestricted = () => {
        // toggles restricted
        setEditingRestricted(!editingRestricted);
    }

    const handleChangeCreator = (event) => {
        // catches changes to series name and searches for suggestions
        setEditingCreator(event.target.value);

        let currentTime = Date.now();
        if ((currentTime - timeOfBackendSearch) / 1000 >= 0.2) {
            timeOfBackendSearch = Date.now;
            searchForCreator(); // CALLS BACKEND
        }
    }

    const handleSelectCreator = (creator) => {
        // adds creator t0 selected creators
        if (selectedCreators != undefined &&  !selectedCreators.includes(creator)) {
            setSelectedCreators(selectedCreators => [...selectedCreators, creator]);
            setEditingCreator("");
        } else {
            setSelectedCreators([creator])
            setEditingCreator("");
        }
    } 


    const handleRemoveCreatorSelection = (index) => {
        // removes author from selection list

        let temp = [];
        for (let i = 0; i < selectedCreators.length; i++) {
            if (i !== index) {
                temp.push(selectedCreators[i]);
            }
        }
        setSelectedCreators(temp);
    }

    const handleAddUnknownCreator = () => {
        // adds author to list

        if (editingCreator !== "") {
            let splitName = editingCreator.split(" ");
            let creatorItem = {
                creatorID: null,
                name: editingCreator,
                first: splitName.slice(0, -1).join(" "),
                last: splitName.slice(-1).join(" "),
                mediaByCreator: []
            }

            setSelectedCreators(selectedCreators => [...selectedCreators, creatorItem]);
            setEditingCreator("");
        }
    }

    async function initateSubmit() {
        // starts all the peices of submitting data to backend

        const [creators] = await Promise.all([
            addCreatorsToDB()
        ]);

        if (props.mediaItem && props.mediaItem.mediaid !== undefined) {
            // editing media
            updateMedia(creators);
            addCoverToDB(props.mediaItem.mediaid);

        } else {
            // new media, must add media then cover
            const [media] = await Promise.all([
                addMediaToDatabase(creators)
            ]);
            addCoverToDB(media.mediaid);
            navigator("/album/" + media.mediaid);
        }
    }


    // ----------------------------------------------------- RENDER

    return (
        <section className={styles.container}>
            <div className={styles.content}>
                <div>
                    <SingleTextInput label="Title" setValue={handleTitleChange} foundValue={editingTitle} size="S" type="text" />
                    <div className={styles.inputGroup}>
                        <div className={styles.label}>Creator(s) </div>


                        {/* MOBILE CREATOR SUGGESTIONS */}
                        {(searchResults !== null && searchResults !== undefined) && window.screen.width < 500 && searchResults[0] !== "series"?
                            <div className={styles.suggestions}>
                               {searchResults[1].map((creator) => <div onClick={() => handleSelectCreator(creator)}> <CreatorSuggestion creatorItem={creator} key={creator.creatorID}/> </div>)}
                                   
                            </div>
                            :
                            null
                        }


                        {selectedCreators?.length > 0 ?
                            <div className={styles.creatorSelections}>
                                {selectedCreators.map((creator, index) =>
                                    <div className={styles.creatorGroup} key={"selected author" + index}>
                                        <CreatorSuggestion creatorItem={creator} />
                                        <img className={styles.removeSelection}
                                            onClick={() => handleRemoveCreatorSelection(index)}
                                            alt="remove button" />
                                    </div>
                                )}
                                {/* INPUT BOX FOR NEW CREATOR */}
                                <div className={styles.creatorInputContainer}>
                                    <input type="text" key="authorInputwithselections"
                                        className={styles.creatorInput}
                                        value={editingCreator}
                                        onChange={handleChangeCreator} />
                                    <button className={styles.addButton}
                                        onClick={handleAddUnknownCreator}
                                        alt="add button">
                                        +
                                    </button>
                                </div>
                            </div>
                            :
                            <div className={styles.creatorInputContainer}>
                                <input type="text" key="authorInputwithoutselections"
                                    className={styles.creatorInput}
                                    value={editingCreator}
                                    onChange={handleChangeCreator} />
                                <button className={styles.addButton}
                                    onClick={handleAddUnknownCreator}
                                    alt="add button">
                                    +
                                </button>
                            </div>
                        }
                    </div>

                    <SingleTextInput label="Description" setValue={handleDescriptionChange} foundValue={editingDescription} size="L" />
                    <SingleTextInput label="Release" setValue={handleReleaseChange} foundValue={editingRelease} size="S" type="date" />
                    <SingleTextInput label="Number of Songs" setValue={handleNumPagesChange} foundValue={editingNumPages} size="S" type="number" min={0} />

                    <div className={styles.inputGroup}>
                        <div className={styles.label}>Genres</div>
                        <GenreInput selectedGenres={selectedGenres} setSelectedGenres={setSelectedGenres} />
                    </div>

                    <div className={styles.inputGroup}>
                        <div className={styles.label}>Cover</div>
                        <input id="input" type="file" accept=".jpg" className={styles.fileSelector} onChange={handleChangeCover} />
                    </div>

                    {
                        role === "admin" ?
                            <div className={styles.inputGroup}>
                                <label htmlFor="restricted" className={styles.label}> Restricted</label>
                                <input className={styles.checkBox} type="checkbox" id="restricted" name="restricted" onChange={handleChangeRestricted} />
                            </div>
                            :
                            null
                    }

                    {/* <div>
                        <SubmediaInput numpages={Number(editingNumPages)} type="album" />
                    </div> */}

                </div>



                {(searchResults !== null && searchResults !== undefined ) && window.screen.width > 500 ?
                    
                    <div className={styles.suggestions}>
                        <div>
                            {searchResults[1].map((creator) => <div onClick={() => handleSelectCreator(creator)}> <CreatorSuggestion creatorItem={creator} /> </div>)}
                        </div>
                    </div>
                    :
                    <div/>
                }

                <div className={styles.inputGroup}>
                    <div />
                    <div className={styles.buttonContainer}>
                        <button className={styles.button} onClick={() => navigator(-1)}>Cancel</button>
                        <button className={styles.saveButton} onClick={initateSubmit}>Save</button>
                    </div>
                </div>
            </div>
        </section>
    )
}